export const environment = {
  "production": false,
  "appName": "@ec/fleet-dashboard-v2",
  "appVersion": "1.0.27",
  "apiUrl": "https://public.ron.ron.elevationcurb.com/api/v1",
  "webAppUrl": "https://webapp.ron.ron.elevationcurb.com",
  "hubAppUrl": "https://hub.ron.ron.elevationcurb.com",
  "installationApiUrl": "https://install.ron.ron.elevationcurb.com/api",
  "liveDataServiceUrl": "wss://lds.ron.ron.elevationcurb.com",
  "timezoneApiKey": "AIzaSyD3NiA0YUwPfnOPGP5fyWkWdNtO5LIlQlU",
  "auth0": {
    "domain": "ron-curbenergy.us.auth0.com",
    "clientId": "ieL5DG16dAuqrGCj1dY6FgvbEvT4Zxjm",
    "redirectUri": window.location.origin,
    "audience": "public.energycurb.com",
    "responseType": "token id_token",
    "scope": "openid profile email",
    "connection": "users"
  }
};
